import { render, staticRenderFns } from "./DeleteTableModal.vue?vue&type=template&id=4bed5e28&scoped=true"
import script from "./DeleteTableModal.vue?vue&type=script&lang=js"
export * from "./DeleteTableModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteTableModal.vue?vue&type=style&index=0&id=4bed5e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed5e28",
  null
  
)

export default component.exports